import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'objectValues',

    // WARN: Use with caution!
    // Use this if the pipe should be called on value changed.
    // pure: false,
})
export class ObjectValuesPipe implements PipeTransform {
    public transform(obj: unknown): string[] {
        if (typeof obj !== 'object' || obj === null) {
            return [];
        }
        return this.flattenValues(obj);
    }

    private flattenValues(obj: object): string[] {
        return Object.values(obj).reduce((acc, val) => {
            if (typeof val === 'object' && val !== null) {
                return [...acc, ...this.flattenValues(val)];
            } else {
                return [...acc, val];
            }
        }, []);
    }
}
